import { Outlet, ScrollRestoration } from "react-router";

import { SiteHeader } from "@/components/site-header";
import { UpdatePrompt } from "@/components/update-prompt";

export default function RootLayout() {
  return (
    <div className="flex min-h-dvh flex-col">
      <SiteHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t py-6">
        <div className="mx-auto max-w-5xl px-4 text-sm text-muted-foreground">
          Built with Vite, React Router, TanStack Query, Tailwind, shadcn/ui and Supabase.
        </div>
      </footer>
      <UpdatePrompt />
      <ScrollRestoration />
    </div>
  );
}
